import cn from "../../lib/classnames";
import InfoCircle from "../icons/InfoCircle";
import KeyCodes from "../../constants/keyCodes";
import React, {useState, useEffect, useRef} from "react";
import styles from "./Toggletip.module.css";
import textStyles from "../../styles/Text.module.css";

const strings = {
    moreInfo: "More Info",
};

type Props = {
    text: string;
};

export default function Toggletip(props: Props) {
    const [open, setOpen] = useState(false);
    const [isAbove, setIsAbove] = useState(true);

    const buttonRef = useRef<HTMLButtonElement>(null);
    const bubbleRef = useRef<HTMLSpanElement>(null);

    function clickListener(e: MouseEvent) {
        if (
            buttonRef.current &&
            e.target instanceof Node &&
            !buttonRef.current.contains(e.target)
        ) {
            setOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener("click", clickListener);
        () => {
            document.removeEventListener("click", clickListener);
        };
    }, []);

    useEffect(() => {
        if (!bubbleRef.current) {
            return;
        }

        const top = bubbleRef.current.getBoundingClientRect().top;
        if (top < 0) {
            setIsAbove(false);
        }
    }, []);

    function showBubble() {
        setOpen(true);
    }

    function onKeyDown(e: React.KeyboardEvent<HTMLButtonElement>) {
        if (e.keyCode === KeyCodes.Escape) {
            setOpen(false);
        }
    }

    return (
        <span className={styles.container}>
            <button
                className={styles.button}
                aria-label={strings.moreInfo}
                onClick={showBubble}
                onKeyDown={onKeyDown}
                ref={buttonRef}
                type="button"
            >
                <InfoCircle />
            </button>
            <span role="status">
                <span
                    ref={bubbleRef}
                    className={cn(
                        textStyles.body,
                        styles.bubble,
                        isAbove ? undefined : styles.below,
                        open ? undefined : styles.hidden,
                    )}
                >
                    {props.text}
                    <div className={cn(styles.outer, isAbove ? styles.bottom : styles.top)}>
                        <div className={cn(styles.inner, isAbove ? styles.bottom : styles.top)} />
                    </div>
                </span>
            </span>
        </span>
    );
}
